import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { DesktopNav } from './navbar/DesktopNav';
import { MobileMenu } from './navbar/MobileMenu';

const LOGO_COLOR = "https://customer-assets.emergentagent.com/job_precision-ops-4/artifacts/lvc5mswl_White%20Glove.png";
const LOGO_WHITE = "https://customer-assets.emergentagent.com/job_precision-ops-4/artifacts/em7gt2l2_White%20Glove%20%28white%29.png";

const navLinks = [
    { label: 'Who We Serve', href: '/who-we-serve' },
    { label: 'How It Works', href: '/how-it-works' },
    { label: 'Oversight', href: '/oversight' },
    { label: 'The Program', href: '/program' },
    { label: 'About', href: '/about' },
    { label: 'Contact', href: '/contact' },
];

export default function Navbar() {
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();
    const isHome = location.pathname === '/';

    const handleScroll = useCallback(() => setScrolled(window.scrollY > 60), [setScrolled]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [handleScroll]);

    useEffect(() => { setMobileOpen(false); }, [location, setMobileOpen]);

    const isDark = isHome && !scrolled;
    const navBg = scrolled || !isHome
        ? 'bg-white shadow-[0_1px_12px_rgba(27,42,74,0.08)]'
        : 'bg-transparent';

    return (
        <header data-testid="navbar" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navBg}`}>
            <div className="max-w-7xl mx-auto px-6 lg:px-12">
                <div className="flex items-center justify-between h-20">
                    <Link to="/" data-testid="navbar-logo" className="flex items-center">
                        <img
                            src={isDark ? LOGO_WHITE : LOGO_COLOR}
                            alt="White Glove Hiring & Leverage"
                            className="h-14 w-auto"
                        />
                    </Link>

                    <DesktopNav navLinks={navLinks} isDark={isDark} />

                    <button
                        className={`lg:hidden p-2 rounded-sm transition-colors ${isDark ? 'text-white hover:bg-white/10' : 'text-navy-900 hover:bg-gray-100'}`}
                        onClick={() => setMobileOpen(!mobileOpen)}
                        data-testid="mobile-menu-toggle"
                        aria-label="Toggle menu"
                    >
                        {mobileOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>

            {mobileOpen && <MobileMenu navLinks={navLinks} isDark={isDark} />}
        </header>
    );
}
